module.exports = __webpack_public_path__ + "static/media/loading.2acb0610.svg";